import {
  PERSONAL_EXTENSION_FILTERABLE_FIELDS,
  type PersonalExtensionFilterableField,
} from '@kirin/api-client/contracts/account-extensions';

export const EXTENSION_TABLE_CONFIG = {
  tableId: 'user-inv-extensions',
  defaultOperator: 'includes',
} as const;

// Page size for infinite-scroll filter dropdowns (Name, Publisher).
export const EXTENSION_FILTER_OPTIONS_PAGE_SIZE = 50;

/**
 * Maps each filterable extension column to its URL state persistence key.
 *
 * `satisfies` enforces full coverage at compile time — adding a new
 * PersonalExtensionFilterableField without a URL key here will be a type error.
 */
export const EXTENSION_FILTER_URL_KEYS = {
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.NAME]: 'en',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.PUBLISHER]: 'ep',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.SOURCE]: 'es',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.IDE]: 'ei',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.FIRST_SEEN_AT]: 'efs',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.LAST_SEEN_AT]: 'els',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.SECURITY]: 'esec',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.RISK_ESTIMATE]: 'erisk',
  [PERSONAL_EXTENSION_FILTERABLE_FIELDS.SCAN_STATUS]: 'escan',
} as const satisfies Record<PersonalExtensionFilterableField, string>;

export const EXTENSION_SOURCE_OPTIONS = [
  { value: 'built-in', label: 'Built-in' },
  { value: 'added', label: 'Added' },
];
